import {COLOR_DANGER, COLOR_SUCCESS, SIZE_FEATURE_LABELS} from '../../../../helpers/constants';

function formatSizes(sizes) {
	if (!sizes || typeof sizes !== 'object') {
		return '—';
	}
	const parts = Object.entries(SIZE_FEATURE_LABELS)
		.filter(([key]) => sizes[key] != null && sizes[key] !== '')
		.map(([key, label]) => `${label} ${sizes[key]}`);
	return parts.length ? parts.join(', ') : '—';
}

export const columns = [
	{
		title: 'ФИО',
		dataIndex: 'user',
		key: 'user',
		render: (user) => user ?? '—',
		sorter: (a, b) => (a.user || '').localeCompare(b.user || '', 'ru')
	},
	{
		title: 'Профессия',
		dataIndex: 'profession',
		key: 'profession',
		render: (profession) => profession ?? '—',
		sorter: (a, b) => (a.profession || '').localeCompare(b.profession || '', 'ru')
	},
	{
		title: 'Подразделение',
		dataIndex: 'division',
		key: 'division',
		render: (division) => division ?? '—',
		sorter: (a, b) => (a.division || '').localeCompare(b.division || '', 'ru')
	},
	{
		title: 'Размеры',
		dataIndex: 'sizes',
		key: 'sizes',
		render: (sizes) => formatSizes(sizes)
	},
	{
		title: 'Норма',
		dataIndex: 'norm',
		key: 'norm',
		render: (norm) => norm ?? 0,
		sorter: (a, b) => (a.norm || 0) - (b.norm || 0),
		align: 'center'
	},
	{
		title: 'Выдано',
		dataIndex: 'given',
		key: 'given',
		render: (given) => given ?? 0,
		sorter: (a, b) => (a.given || 0) - (b.given || 0),
		align: 'center'
	},
	{
		title: 'Срок отсчёта',
		dataIndex: 'start_date',
		key: 'start_date',
		render: (date) => date ? new Date(date).toLocaleDateString('ru-RU') : '—',
		sorter: (a, b) => new Date(a.start_date || 0) - new Date(b.start_date || 0),
		align: 'center'
	},
	{
		title: 'Потребность',
		dataIndex: 'need',
		key: 'need',
		render: (need) => {
			const value = need ?? 0;
			const color = value > 0 ? COLOR_DANGER : COLOR_SUCCESS;
			return <span style={{color, fontWeight: 600}}>{value}</span>;
		},
		sorter: (a, b) => (a.need || 0) - (b.need || 0),
		align: 'center'
	}
];
